import React, { useState } from 'react';
import './Careers.css';
import JobDetailsModal from '../components/JobDetailsModal';
import { jobDescriptions } from '../data/jobDescriptions';

const Careers = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const openPositions = [
    {
      role: 'Chairman of Board',
      applicationUrl: '/job-applications/AGWestern_Chairman_Employment_Application.pdf'
    },
    {
      role: 'CPO (Chief Product Officer)',
      applicationUrl: '/job-applications/AGWestern_CPO_Employment_Application.pdf'
    },
    {
      role: 'CDO (Chief Data Officer)',
      applicationUrl: '/job-applications/AGWestern_CDO_Employment_Application.pdf'
    },
    {
      role: 'COO (Chief Operating Officer)',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/74091jhh_AGWestern_COO_Employment_Application.pdf'
    },
    {
      role: 'CRO (Chief Revenue Officer)',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/x9bp1laf_AGWestern_CRO_Employment_Application.pdf'
    },
    {
      role: 'CXO (Chief Experience Officer)',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/aht29bvy_AGWestern_CXO_Employment_Application.pdf'
    },
    {
      role: 'CIO (Chief Information Officer)',
      applicationUrl: '/job-applications/AGWestern_CIO_Employment_Application.pdf'
    },
    {
      role: 'CLO (Chief Legal Officer)',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/9dhjwtsi_AGWestern_CLO_Employment_Application.pdf'
    },
    {
      role: 'CSO (Chief Security Officer)',
      applicationUrl: '/job-applications/AGWestern_CSO_Employment_Application.pdf'
    },
    {
      role: 'VP of Gov. Affairs',
      applicationUrl: 'https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/il48b0i8_AGWestern_VP_Government_Affairs_Employment_Application.pdf'
    },
    {
      role: 'Office Secretary',
      applicationUrl: '/job-applications/AGWestern_Office_Secretary_Employment_Application.pdf'
    }
  ];

  return (
    <div className="careers-page">
      {/* Hero Section */}
      <section className="careers-hero">
        <div className="careers-hero-content">
          <h1>Careers</h1>
          <p>Join America's Secondary Passenger Rail and help shape the future of transportation</p>
        </div>
      </section>

      {/* Open Positions Section */}
      <section className="careers-content">
        <div className="careers-container">
          <div className="careers-intro">
            <h2>Current Open Positions</h2>
            <p>
              AG&WESTERN Rail Inc. is growing and we're looking for talented professionals to join our team. 
              Explore our open positions below and become part of our mission to revolutionize rail transportation across North America.
            </p>
          </div>

          <div className="positions-grid">
            {openPositions.map((position) => (
              <div 
                key={position.role} 
                className="position-card"
                onClick={(e) => {
                  if (position.applicationUrl && jobDescriptions[position.role]) {
                    e.preventDefault();
                    setSelectedJob({
                      ...jobDescriptions[position.role],
                      applicationUrl: position.applicationUrl
                    });
                    setShowModal(true);
                  } else if (!position.applicationUrl) {
                    alert(`Job posting for ${position.role} will be available soon!`);
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                <span className="position-card-title">{position.role}</span>
                <span className="position-card-action">
                  {position.applicationUrl ? 'Apply Now →' : 'View Details →'}
                </span>
              </div>
            ))}
          </div>

          <div className="application-instructions">
            <p>
              <strong>📄 Application Instructions:</strong> Click "Apply Now" to download the position's employment application. 
              Fill out the form completely and email your completed application to{' '}
              <a href="mailto:careers@agwesternrail.com">careers@agwesternrail.com</a>
            </p>
          </div>

          <div className="careers-contact">
            <p>
              Interested in a position? Contact us at{' '}
              <a href="mailto:careers@agwesternrail.com">careers@agwesternrail.com</a>
            </p>
          </div>
        </div>
      </section>

      <JobDetailsModal 
        job={selectedJob}
        onClose={() => {
          setShowModal(false);
          setSelectedJob(null);
        }}
        onContinue={() => {
          if (selectedJob?.applicationUrl) {
            window.open(selectedJob.applicationUrl, '_blank');
          }
        }}
      />
    </div>
  );
};

export default Careers;
